// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { History } from "./History";
import {
  HistoryFromJSON,
  HistoryFromJSONTyped,
  HistoryToJSON,
  HistoryToJSONTyped,
} from "./History";

/**
 *
 * @export
 * @interface CursorPageHistory
 */
export interface CursorPageHistory {
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  items: Array<History>;
  /**
   *
   */
  limit?: number | null;
}

/**
 * Check if a given object implements the CursorPageHistory interface.
 */
export function instanceOfCursorPageHistory(value: object): value is CursorPageHistory {
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function CursorPageHistoryFromJSON(json: any): CursorPageHistory {
  return CursorPageHistoryFromJSONTyped(json, false);
}

export function CursorPageHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CursorPageHistory {
  if (json == null) {
    return json;
  }
  return {
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    items: (json["items"] as Array<any>).map(HistoryFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
  };
}

export function CursorPageHistoryToJSON(json: any): CursorPageHistory {
  return CursorPageHistoryToJSONTyped(json, false);
}

export function CursorPageHistoryToJSONTyped(
  value?: CursorPageHistory | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    next: value["next"],
    items: (value["items"] as Array<any>).map(HistoryToJSON),
    limit: value["limit"],
  };
}
